module.exports = __webpack_public_path__ + "img/rage.549e72b9.svg";